import { render, staticRenderFns } from "./ProductAgoraDocumentation.vue?vue&type=template&id=b59f1422&scoped=true&"
import script from "./ProductAgoraDocumentation.vue?vue&type=script&lang=js&"
export * from "./ProductAgoraDocumentation.vue?vue&type=script&lang=js&"
import style0 from "./ProductAgoraDocumentation.vue?vue&type=style&index=0&id=b59f1422&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b59f1422",
  null
  
)

export default component.exports